'use strict';
var novicell = novicell || {};

novicell.stickyNav = novicell.stickyNav || function () {

    var pageScrollPosition = 0;
    var scrollDirection = "down";
    var lastScrollUpPosition = 0;
    var lastPageScrollPosition = 0;
    var scrolledSinceLastDirectionChange = 0;

    var alwaysShowWhenAboveThis = 1000;
    var showWhenNotScrolledMoreThan = 76;

    var siteHeaderHideClass = "o-siteheader--hidden";

    function run() {
        var siteHeader = document.querySelector('#o-siteheader');
        if(siteHeader != null){
            setCurrentPageScrollPosition();
            setScrollDirection();
            if(pageScrollPositionLargeEnoughToHideHeader() && scrollDirection == "down" && scrollSinceDirectionChangeLargeEnoughToHideHeader())
            {
                siteHeader.classList.add(siteHeaderHideClass);
            }else{
                siteHeader.classList.remove(siteHeaderHideClass);
            }
        }
    }
    function setCurrentPageScrollPosition(){
        pageScrollPosition = window.pageYOffset;
    }
    function pageScrollPositionLargeEnoughToHideHeader(){
        return pageScrollPosition > alwaysShowWhenAboveThis;
    }
    function setScrollDirection(){
        if(pageScrollPosition >= lastPageScrollPosition){
            if(scrollDirection == "up"){
                lastScrollUpPosition = pageScrollPosition;
            }
            scrollDirection = "down";
        }else{
            scrollDirection = "up";
        }
        lastPageScrollPosition = pageScrollPosition;
    }
    function scrollSinceDirectionChangeLargeEnoughToHideHeader(){
        return pageScrollPosition - lastScrollUpPosition > showWhenNotScrolledMoreThan;
    }

    return {
        run: run
    };
}();
